var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFreeParkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "icon parking lot",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.714 48v-4.571h3.429a2.286 2.286 0 1 1 0 4.571zm13.715-16A4.573 4.573 0 0 1 32 36.571v22.858A4.576 4.576 0 0 1 27.429 64H4.571A4.573 4.573 0 0 1 0 59.429V36.571A4.571 4.571 0 0 1 4.571 32zM24 45.714a6.818 6.818 0 0 0-6.857-6.857H12a2.856 2.856 0 0 0-2.857 2.857v13.143a2.286 2.286 0 1 0 4.571 0v-2.286h3.429A6.859 6.859 0 0 0 24 45.714z",
    style: {
      fill: "#2e3540"
    },
    transform: "translate(0 -32)"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeParkIcon);
export default __webpack_public_path__ + "static/media/free-park-icon.1f4350f3c0170c223bc3ff32d43e8e39.svg";
export { ForwardRef as ReactComponent };